export default class signInCardsEnum {
    static LABELS = {
        SIZES: [
            {
                key: 'QR_3X3',
                value: 'QR'
            },
            {
                key: 'QR',
                value: 'QR'
            },
            {
                key: '_2X5',
                value: '2 x 5'
            },
            {
                key: '_2X7',
                value: '2 x 7'
            },
            {
                key: '_3X8',
                value: '3 x 8'
            }
        ],
        DEFAULT_SIZE: 'QR_3X3'
    };

    static STUDENTS = 'students';
    static TEACHERS = 'teachers';
}



// WEBPACK FOOTER //
// ./app/containers/sign-in-cards/constants.js